import React, {useState} from "react";
import {Message, Grid, Form, Button, Divider, Icon} from "semantic-ui-react";
import _ from 'lodash'

function DialogFlashCardAdder(
    {
        questionNumber,
        id,
        value,
        handleSetDialogFlashCardData,
        handleAddQuestionField,
        handleAddResponseField,
        handleSubtractQuestionField,
        handleSubtractResponseField
    }
) {

    const [numberOfQuestionFields, setNumberOfQuestionFields] = useState(1);
    const [numberOfResponseFields, setNumberOfResponseFields] = useState(1);

    const handleAddQuestionFields = (id) => {
        setNumberOfQuestionFields(prevState => prevState + 1);
        handleAddQuestionField(id);
    };
    const handleAddResponseFields = (id) => {
        setNumberOfResponseFields(prevState => prevState + 1);
        handleAddResponseField(id);

    };
    const handleSubtractQuestionFields = (id) => {
        setNumberOfQuestionFields(prevState => prevState - 1);
        handleSubtractQuestionField(id);
    };
    const handleSubtractResponseFields = (id) => {
        setNumberOfResponseFields(prevState => prevState - 1);
        handleSubtractResponseField(id);
    };
    return (
        value ?
            <div style={{marginTop: 10, marginRight: 5, marginLeft: 5}}>
                <div style={{border: ' 3px solid', textAlign: 'left', width: 800}}>

                    <Message attached header={`Flash Card ${questionNumber + 1}`}
                             style={{paddingLeft: 10, paddingRight: 10,}}/>

                    <Form className='attached fluid segment' width={8}>
                        {
                            _.times(numberOfQuestionFields, (i) => (
                                <>
                                    <label key={i} style={{color: '#002b70'}}>Speaker A Samoan Phrase:</label>
                                    <Form.Input
                                        fluid
                                        placeholder='Samoan Phrase'
                                        type='text'
                                        name='question'
                                        id={id}
                                        index={i}
                                        value={value.question[i]}
                                        onChange={(e)=>handleSetDialogFlashCardData(e, i)}
                                    />
                                    <label style={{color: '#002b70'}}>Speaker A English Translation:</label>
                                    <Form.Input
                                        fluid
                                        placeholder='English Phrase'
                                        type='text'
                                        name='englishQuestion'
                                        id={id}
                                        index={i}
                                        value={value.englishQuestion[i]}
                                        onChange={(e)=>handleSetDialogFlashCardData(e, i)}
                                    />
                                    <label style={{color: '#002b70'}}>Speaker A Audio (Optional):</label>
                                    {
                                        value.questionAudio[i] ?
                                            <>
                                                <Form.Input width={5} type='text' index={i} value={value.questionAudio[i]} id={id}/>
                                                <b>If you would like to change the audio, insert new audio file here</b>
                                                <Form.Input width={5} type='file' index={i} name='questionAudio' id={id}
                                                            onChange={(e)=>handleSetDialogFlashCardData(e, i)}
                                                />
                                            </>
                                            :
                                            <Form.Input width={5} type='file' name='questionAudio'
                                                        value={value.questionAudio[i]} id={id}
                                                        index={i}
                                                        onChange={(e)=>handleSetDialogFlashCardData(e, i)}
                                            />

                                    }
                                </>
                            ))
                        }

                        <Button id={id} onClick={()=>handleAddQuestionFields(id)} icon><Icon name='plus'/></Button>
                        {
                            numberOfQuestionFields > 1 ?
                                <Button id={id} onClick={()=>handleSubtractQuestionFields(id)} icon><Icon name='minus'/></Button>
                                :
                                null
                        }

                        <Divider/>
                        {
                            _.times(numberOfResponseFields, (i) =>(
                                <>
                                    <label key={i} style={{color: '#00540a'}}>Speaker B Samoan Phrase:</label>
                                    <Form.Input
                                        fluid
                                        placeholder='Samoan Phrase'
                                        type='text'
                                        name='response'
                                        value={value.response[i]}
                                        id={id}
                                        index={i}
                                        onChange={(e)=>handleSetDialogFlashCardData(e, i)}
                                    />
                                    <label style={{color: '#00540a'}}>Speaker B English Translation:</label>
                                    <Form.Input
                                        fluid
                                        placeholder='English Phrase'
                                        type='text'
                                        value={value.englishResponse[i]}
                                        name='englishResponse'
                                        id={id}
                                        index={i}
                                        onChange={(e)=>handleSetDialogFlashCardData(e, i)}
                                    />
                                    <label style={{color: '#00540a'}}>Speaker B Audio (Optional):</label>
                                    {
                                        value.questionAudio[i] ?
                                            <>
                                                <Form.Input width={5} type='text' index={i} value={value.responseAudio[i]} id={id}/>
                                                <b>If you would like to change the audio, insert audio file here</b>
                                                <Form.Input width={5} type='file' index={i} name='responseAudio' id={id}
                                                            onChange={(e)=>handleSetDialogFlashCardData(e, i)}
                                                />
                                            </>
                                            :
                                            <Form.Input width={5} type='file' index={i} name='responseAudio' id={id}
                                                        value={value.responseAudio[i]}
                                                        onChange={(e)=>handleSetDialogFlashCardData(e, i)}
                                            />

                                    }
                                </>
                            ))
                        }


                        <Button id={id} onClick={()=>handleAddResponseFields(id)} icon><Icon name='plus'/></Button>
                        {
                            numberOfResponseFields > 1 ?
                                <Button id={id} onClick={()=>handleSubtractResponseFields(id)} icon><Icon name='minus'/></Button>
                                :
                                null
                        }

                    </Form>
                </div>
            </div>
            :
            <div style={{marginTop: 10, marginRight: 5, marginLeft: 5}}>
                <div style={{border: ' 3px solid', textAlign: 'left', width: 800}}>
                    <Message attached header={`Flash Card ${questionNumber + 1}`}
                             style={{paddingLeft: 10, paddingRight: 10,}}/>
                    <Form className='attached fluid segment' width={8}>
                        <label style={{color: '#002b70'}}>Speaker A Samoan Phrase:</label>
                        <Form.Input
                            fluid
                            placeholder='Samoan Phrase'
                            type='text'
                            name='question'
                            value={value.question}
                            id={id}
                            onChange={handleSetDialogFlashCardData}
                        />
                        <label style={{color: '#002b70'}}>Speaker A English Translation:</label>
                        <Form.Input
                            fluid
                            placeholder='English Phrase'
                            type='text'
                            name='englishQuestion'
                            id={id}
                            onChange={handleSetDialogFlashCardData}
                        />
                        <label style={{color: '#002b70'}}>Speaker A Audio (Optional):</label>
                        <Form.Input width={5} type='file' name='questionAudio' id={id}
                                    onChange={handleSetDialogFlashCardData}/>
                        <Divider/>
                        <label style={{color: '#00540a'}}>Speaker B Samoan Phrase:</label>
                        <Form.Input
                            fluid
                            placeholder='Samoan Phrase'
                            type='text'
                            name='response'
                            id={id}
                            onChange={handleSetDialogFlashCardData}
                        />
                        <label style={{color: '#00540a'}}>Speaker B English Translation:</label>
                        <Form.Input
                            fluid
                            placeholder='English Phrase'
                            type='text'
                            name='englishResponse'
                            id={id}
                            onChange={handleSetDialogFlashCardData}
                        />
                        <label style={{color: '#00540a'}}>Speaker B Audio (Optional):</label>

                        <Form.Input width={5} type='file' name='responseAudio' id={id}
                                    onChange={handleSetDialogFlashCardData}/>


                    </Form>
                </div>
            </div>
    )
}


export default DialogFlashCardAdder
